// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalTags_container__17QAh","description":"ModalTags_description__2SDS5"};